import React from "react";
import { Paper, Typography, Box, Tooltip } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import colors from "../../../Constants/colors";
import { PredefinedSectionDocument } from "../../../Models/appendixStructure";

export interface PlaceholderCardDocProps {
  doc: PredefinedSectionDocument;
}

const LABEL_SLOT_W = 24; // Supports two-digit subsection numbers (e.g. 20.10, 20.13)

export const PlaceholderCardDoc: React.FC<PlaceholderCardDocProps> = ({
  doc,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        width: 550,
        maxWidth: 550,
        minHeight: 56,
        pl: 1.2,
        pr: 1.2,
        py: 1,
        display: "flex",
        alignItems: "center",
        border: `1px solid ${colors.gray200}`,
        borderLeft: `4px solid ${colors.primary_dark}`,
        borderRadius: 2,
        bgcolor: colors.white,
        cursor: "default",
      }}
    >
      {doc.order ? (
        <Box
          sx={{
            flex: `0 0 ${LABEL_SLOT_W}px`,
            mr: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            fontWeight: 700,
            color: colors.accent,
            whiteSpace: "nowrap",
            userSelect: "none",
          }}
        >
          {doc.order}.
        </Box>
      ) : null}

      <InsertDriveFileIcon sx={{ color: colors.accent }} />

      <Box sx={{ flex: "1 1 auto", minWidth: 0, ml: 1 }}>
        <Tooltip title={doc.name} placement="top">
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: colors.primary_dark,
            }}
          >
            {doc.name}
          </Typography>
        </Tooltip>
      </Box>
    </Paper>
  );
};
